module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Wolves.b3c596e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Wolves.jpg
// module id = 0zrX
// module chunks = 0